import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { WelcomeSplashService } from '@core/components/welcome-splash/welcome-splash.service';
import { BcmBooking } from '@shared/models/bcm-booking';
import { BookingEntryService } from '@modules/bcm/booking-v2';

@Component({
    selector: 'bcm-booking-link',
    templateUrl: './booking-link.component.html',
    standalone: false
})
export class BookingLinkComponent implements OnChanges {

    @Input()
    public booking!: BcmBooking | { id: number };

    @Input()
    public bookingId!: number;

    @Input()
    public dataTest: string;

    @Input()
    public additionalInfo: string;

    @Input()
    public disableLink: boolean;

    @Input()
    public openInNewTab = false;

    public viewData: string;

    @Output()
    public clicked = new EventEmitter<void>();

    private readonly _bookingEntryService = inject(BookingEntryService);
    private readonly _welcomeSplashService = inject(WelcomeSplashService);

    ngOnChanges(): void {
        const booking = this.booking || (this.bookingId ? { id: this.bookingId } : null);
        
        if (booking && booking.id) {
            this.viewData = [
                `#${booking.id}`,
                this.additionalInfo,
            ].filter(item => item != null)
                .join(' - ');
        } else {
            this.viewData = null;
        }
    }

    get resolvedBookingId(): number | null {
        const booking = this.booking || (this.bookingId ? { id: this.bookingId } : null);
        return booking?.id ?? null;
    }

    prepareNewTab(event: MouseEvent): void {
        if (!this.openInNewTab || this.disableLink) {
            return;
        }

        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }

        this._welcomeSplashService.prepareForInternalNewTab();
    }

    click(event: MouseEvent): void {
        if (this.disableLink) {
            return;
        }

        const bookingId = this.resolvedBookingId;

        if (!bookingId) {
            return;
        }

        if (this.openInNewTab || event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
            return;
        }

        event.preventDefault();

        this._bookingEntryService.editBooking(bookingId).subscribe();

        this.clicked.emit();
        event.stopPropagation();
    }
}

